import { safeLocalStorage, useAdminStore } from 'shared-components';

type FontSizeValue = 'normal' | 'large' | 'x-large';

const STORAGE_KEY = 'fontSize';
const APP_DEFAULT: FontSizeValue = 'normal';
const SIZES: Record<FontSizeValue, boolean> = {
  normal: true,
  large: true,
  'x-large': true,
};

const HTML_CLASSES: Record<FontSizeValue, string | null> = {
  normal: null,
  large: 'font-size-large',
  'x-large': 'font-size-xlarge',
};

const fontSize = {
  get: (): FontSizeValue => {
    const stored = safeLocalStorage.getItem(STORAGE_KEY) as FontSizeValue | null;
    return stored && SIZES[stored] ? stored : APP_DEFAULT;
  },

  set: (value: FontSizeValue): void => {
    if (value === APP_DEFAULT) {
      safeLocalStorage.removeItem(STORAGE_KEY);
    } else {
      safeLocalStorage.setItem(STORAGE_KEY, value);
    }

    useAdminStore.getState().setFontSize(value);
    fontSize.apply(value);
  },

  restore: (): void => {
    const stored = fontSize.get();
    useAdminStore.getState().setFontSize(stored);
    fontSize.apply(stored);
  },

  apply: (value: FontSizeValue = fontSize.get()): void => {
    const root = document.documentElement;

    Object.values(HTML_CLASSES).forEach((className) => {
      if (className) root.classList.remove(className);
    });

    const next = HTML_CLASSES[value];
    if (next) root.classList.add(next);
  },
};

export { fontSize };
export type { FontSizeValue };
